import React, { useState } from 'react';
import { Button, FormGroup, Form } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { appropriateCargoItem } from '../../../../actions';
import { CARGO_ITEM_STATUS } from '../../../../config/constants';
import { generatePutAppropriateCargoItem } from '../../../../config/endpoints';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import Immutable from 'immutable';
import { tzNormalizeDate } from '../../../../utils/date';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import Modal from '../../../common/modal/Modal';
import DatePicker from '../../../common/forms/input/DatePicker';
import { INT_DATE_FORMAT } from '../../../../config/locale';

const AppropriateCargoItemButton = ({
  cargoItemDetail,
  dispatchChangeCargoItemStatus,
  handleSubmit,
  reset,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const cargoItem = cargoItemDetail.toJS();

  const openConfirmationModal = () => {
    reset();
    setShowConfirmationModal(true);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handleAppropriate = (formValues) => {
    setShowConfirmationModal(false);

    dispatchChangeCargoItemStatus({
      cargoItemId: cargoItem.cargoItemId,
      comment: formValues.comment,
      date: tzNormalizeDate({ date: formValues.date, format: INT_DATE_FORMAT }),
    });
  };

  if (
    !cargoItem.cargoItemDetail ||
    cargoItem.cargoItemDetail.status === CARGO_ITEM_STATUS.APPROPRIATE.value
  ) {
    return null;
  }

  const modalBody = (
    <Form onSubmit={handleSubmit(handleAppropriate)}>
      <p className="mb-4">
        ¿Estás seguro que deseas pasar esta encomienda a estado de Apropiación?
      </p>

      <FormGroup row>
        <FormItem label="Comentario" required>
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Fecha de aviso a RRHH" required>
          <Field
            name="date"
            component={DatePicker}
            validate={[isRequired, validateEndDate]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter
        saveButtonColor="danger"
        saveButtonIcon={null}
        saveButtonText="Apropiar"
      >
        <Button color="secondary" onClick={closeConfirmationModal}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );

  return (
    <>
      <Button color="danger" onClick={openConfirmationModal}>
        Apropiación
      </Button>
      <Modal
        show={showConfirmationModal}
        title="Confirmar Apropiación"
        body={modalBody}
        size="md"
        onClickClose={closeConfirmationModal}
      />
    </>
  );
};

AppropriateCargoItemButton.propTypes = {
  dispatchChangeCargoItemStatus: PropTypes.func.isRequired,
  cargoItemDetail: PropTypes.instanceOf(Immutable.Map).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChangeCargoItemStatus: appropriateCargoItem,
};

const formComponent = reduxForm({
  form: 'AppropriateCargoItemForm',
})(AppropriateCargoItemButton);

const connectedComponent = connect(null, mapDispatchToProps)(formComponent);

export default withEndpointAuthorization({
  url: generatePutAppropriateCargoItem(0),
  permissionType: PUT,
})(connectedComponent);
